import $ from 'jquery';

// Highlight JS plugin
// import hljs from 'highlight.js/lib/common';
// import 'highlight.js/styles/github.css';

export default class Components {

	// Tooltip
	initTooltipPlugin() {
		$.fn.tooltip && $('[data-toggle="tooltip"]').tooltip();
	}

	// Popover
	initPopoverPlugin() {
		$.fn.popover && $('[data-bs-toggle="popover"]').each(function(idx, obj) {
			$(this).popover();
		});
	}

	// Toast
	initToastPlugin() {
		$.fn.toast && $('[data-toggle="toast"]').toast();
	}

	// Form validation
	initFormValidation() {
		$('.needs-validation').on('submit', /** @this {HTMLInputElement} */ function(event) {
			$(this).addClass('was-validated');
			// @ts-ignore
			if (this.checkValidity() === false) {
				event.preventDefault();
				event.stopPropagation();
				return false;
			}
			return true;
		});
	}

	// Password view button
	initShowHidePassword() {
		$('[data-password]').on('click', function() {
			if ($(this).attr('data-password') === 'false') {
				$(this).siblings('input').attr('type', 'text');
				$(this).attr('data-password', 'true');
				$(this).addClass('show-password');
			}
			else {
				$(this).siblings('input').attr('type', 'password');
				$(this).attr('data-password', 'false');
				$(this).removeClass('show-password');
			}
		});
	}

	// Multi-dropdown
	initMultiDropdown() {
		$('.dropdown-menu a.dropdown-toggle').on('click', function() {
			if (!$(this)
				.next()
				.hasClass('show')) {
				$(this)
					.parents('.dropdown-menu')
					.first()
					.find('.show')
					.removeClass('show');
			}
			const $subMenu = $(this).next('.dropdown-menu');
			$subMenu.toggleClass('show');

			return false;
		});
	}

	// Syntax highlight
	initSyntaxHighlight() {
		for (const [_, element] of document.querySelectorAll('pre span.escape').entries()) {
			const text = element.textContent.replace(/^\n/, '').trimEnd();
			let to_kill = Number.POSITIVE_INFINITY;
			const lines = text.split('\n');
			for (const line of lines) {
				if (!line.trim()) {
					continue;
				}
				to_kill = Math.min(line.search(/\S/), to_kill);
			}
			const out = [];
			for (const line of lines) {
				out.push(line.replaceAll(new RegExp(`^ {${to_kill}}`, 'g'), ''));
			}
			// @ts-ignore
			element.textContent = out.join('\n');
		}

		for (const block of document.querySelectorAll('pre span.escape')) {
			// @ts-ignore
			hljs.highlightElement(block);
		}
	}

	initTabs() {
		const $tabsContainer = $('#header-tabs');
		const $tabsItems = $tabsContainer.children('.nav-item');
		const options = $tabsContainer.data('mobile-tabs') || {};
		const $tabsHolder = $(options.containerHtml || '<li class="nav-item-tabs d-none"></li>');
		const $toggleButton = $(options.toggleButtonHtml || '<a class="btn btn-white bg-transparent border-0 px-2" data-bs-toggle="dropdown" href="javascript:void(0);"><span title="View tabs" data-bs-toggle="dropdown"><i class="mdi mdi-dots-horizontal"></i></span></a>');
		const $dropdownContainer = $(options.itemContainerHtml || '<div class="dropdown-menu dropdown-menu-end"></div>');
		const foldOffset = options.foldOffset || 0;

		// Add markup to dom
		$tabsHolder.append($toggleButton);
		$tabsHolder.append($dropdownContainer);
		$tabsContainer.append($tabsHolder);

		// Mobile tabs collection
		let $tabsDropdownItems = $();
		let tabsTotal = 0;

		// Add mobile tabs as dropdown elements
		$tabsItems.each(function() {
			const $tab = $(this);
			const $tabLink = $tab.children('a.nav-link').first();
			const markup = (options.itemHtml || '<a class="dropdown-item" href="javascript:void(0);"></a>').replaceAll('[[url]]', $tabLink.attr('href')).replaceAll('[[label]]', $tabLink.html());
			const $dropdownItem = $tabLink.hasClass('active') ? $(markup).addClass('active') : $(markup);
			// $dropdownItem.find('.badge').removeClass('bg-light').addClass('bg-secondary');
			$dropdownContainer.append($dropdownItem);
			$tabsDropdownItems = $tabsDropdownItems.add($dropdownItem);
			tabsTotal++;
		});

		function handleTabs() {
			let tabsVisible = 0;

			for (const [key, tab] of Object.entries($tabsItems.get())) {
				const $tab = $(tab);
				const index = Number(key);

				if (tab.getBoundingClientRect().right <= (document.documentElement.clientWidth - foldOffset)) {
					tabsVisible++;
					$tab.removeClass('invisible');
					$tabsDropdownItems.eq(index).addClass('d-none');
				}
				else {

					// Don't hide the first tab
					if (tabsVisible >= 1) {
						$tab.addClass('invisible');
						$tabsDropdownItems.eq(index).removeClass('d-none');
					}
				}
			}

			if (tabsVisible === tabsTotal) {
				$tabsHolder.addClass('d-none');
			}
			else {
				$tabsHolder.removeClass('d-none');
			}
		}

		window.addEventListener('resize', handleTabs, { passive: true });
		// mpro.get$W().on('resize.initTabs', handleTabs);
		handleTabs();
	}

	// initializing
	init() {
		// this.initTabs();
		// this.initTooltipPlugin();
		// this.initPopoverPlugin();
		// this.initToastPlugin();
		// this.initFormValidation();
		// this.initShowHidePassword();
		// this.initMultiDropdown();
		// this.initSyntaxHighlight();
	}
}
